/* tslint:disable */
//  This file was automatically generated and should not be edited.

// Contact information for different user and clients
export enum ContactType {
  sms = "sms",
  email = "email",
  user = "user",
}


export type ClientInput = {
  clientId: string,
  typedId: string,
  name: string,
  icon?: string | null,
  brief?: string | null,
  location?: GeoLocationInput | null,
  contacts: Array< ContactInfoInput >,
};

export type GeoLocationInput = {
  lng: number,
  lat: number,
};

export type ContactInfoInput = {
  contactType: ContactType,
  contact: string,
};

export type ClientDeleteInput = {
  clientId: string,
  typedId?: string | null,
};

export type ClientConnectionInput = {
  clientId?: string | null,
  typedId?: string | null,
  nextToken?: string | null,
};

export type ThreadInput = {
  clientId: string,
  typedId: string,
  context?: string | null,
  brief?: string | null,
  detail?: string | null,
};

export type UserCommentInput = {
  clientId: string,
  typedId: string,
  comment: string,
};

export type DashboardInput = {
  clientId: string,
  typedId: string,
  icon?: string | null,
  name: string,
  layout?: LayoutsInput | null,
  configurations?: Array< ConfigurationInput | null > | null,
};

export type LayoutsInput = {
  lg: Array< LayoutInput >,
  md: Array< LayoutInput >,
  sm: Array< LayoutInput >,
  xs: Array< LayoutInput >,
};

export type LayoutInput = {
  i: string,
  x: number,
  y: number,
  w: number,
  h: number,
};

export type ConfigurationInput = {
  key: string,
  value?: string | null,
};

export enum ChartType {
  table = "table",
  line = "line",
  bar = "bar",
  scatter = "scatter",
  pie = "pie",
  donut = "donut",
  radar = "radar",
  polar = "polar",
  geographic = "geographic",
}


// Enum Definitons
export enum DurationFromType {
  sinceAction = "sinceAction",
  sinceState = "sinceState",
  minute = "minute",
  hour = "hour",
  days = "days",
}


export type ChartInput = {
  clientId: string,
  typedId: string,
  name: string,
  chartType: ChartType,
  breakOnError?: boolean | null,
  geospread?: boolean | null,
  min?: number | null,
  max?: number | null,
  sensorType: string,
  measurementUnit: string,
  include?: Array< FilterInput | null > | null,
  exclude?: Array< FilterInput | null > | null,
  durationFromType: DurationFromType,
  durationFrom: string,
  configurations?: Array< ConfigurationInput | null > | null,
};

export type FilterInput = {
  unitIds?: Array< string > | null,
  unitGroups?: Array< string > | null,
  unitSensors?: Array< string > | null,
};

// The statistics type to be defined
export enum StatisticsType {
  value = "value",
  min = "min",
  max = "max",
  total = "total",
  average = "average",
}


// What the stat will be compared to
export enum StatComparisionType {
  notCompared = "notCompared",
  percentage = "percentage",
  addition = "addition",
  subtraction = "subtraction",
  division = "division",
  multiplication = "multiplication",
}


// Trigger Conditions and Enums
export enum TriggerSevirity {
  InActive = "InActive",
  Informative = "Informative",
  Warning = "Warning",
  Alert = "Alert",
  Critical = "Critical",
}


export enum Conditions {
  Equal = "Equal",
  NotEqual = "NotEqual",
  LessThan = "LessThan",
  LessOrEqual = "LessOrEqual",
  GreaterThan = "GreaterThan",
  GreaterOrEqual = "GreaterOrEqual",
}


export type TriggerableStatInput = {
  clientId: string,
  typedId: string,
  statIndex?: number | null,
  name?: string | null,
  associatedChart?: string | null,
  sensorType?: string | null,
  measurementUnit?: string | null,
  include?: Array< FilterInput | null > | null,
  exclude?: Array< FilterInput | null > | null,
  statType: StatisticsType,
  comparisionType: StatComparisionType,
  comparedToStatType?: StatisticsType | null,
  comparisionValue?: number | null,
  triggers?: Array< TriggerInput > | null,
};

export type TriggerInput = {
  id?: string | null,
  name: string,
  description?: string | null,
  triggerSevirity: TriggerSevirity,
  triggerCondition: Conditions,
  notifyOnFailure?: boolean | null,
  value?: number | null,
  state?: string | null,
  contacts?: Array< ContactInfoInput > | null,
};

export type UnitGroupInput = {
  clientId: string,
  typedId: string,
  icon?: string | null,
  name: string,
  priority?: number | null,
  refreshRate?: number | null,
  isAlwaysOnline?: boolean | null,
  unitSensorRenaming?: Array< UnitSensorRenameInput | null > | null,
  configurations?: Array< ConfigurationInput | null > | null,
};

export type UnitSensorRenameInput = {
  alias?: string | null,
  name?: string | null,
};

// Different type of payload that could be given with action
export enum PayloadType {
  noPayload = "noPayload",
  optioned = "optioned",
  String = "String",
  number = "number",
}


export type SensorTypeInput = {
  clientId: string,
  typedId: string,
  icon?: string | null,
  name: string,
  isStateBased?: boolean | null,
  possibleStates?: Array< string | null > | null,
  measurement: string,
  commUnit: string,
  maxValue?: number | null,
  minValue?: number | null,
  significantDifference?: number | null,
  significantTimeDifference?: number | null,
  configurations?: Array< ConfigurationInput | null > | null,
  conditionalState?: Array< ConditionalStateInput | null > | null,
  possibleActions?: Array< ActionDefinitionInput | null > | null,
};

export type ConditionalStateInput = {
  condition: Conditions,
  value: number,
  state?: string | null,
};

export type ActionDefinitionInput = {
  name: string,
  possiblePayloads?: Array< ActionPayloadInput | null > | null,
};

export type ActionPayloadInput = {
  payloadType?: PayloadType | null,
  payloadOptions?: Array< DropDownInput > | null,
};

export type DropDownInput = {
  icon: string,
  key: string,
  text: string,
  value: string,
};

export type UnitConnectionInput = {
  unitId?: string | null,
  clientId?: string | null,
  typedId?: string | null,
  nextToken?: string | null,
};

// This are the unit state
export enum UnitState {
  test = "test",
  prototyped = "prototyped",
  demo = "demo",
  disabled = "disabled",
}


export type SuperUnitInput = {
  unitId: string,
  typedId: string,
  clientId: string,
  divisionId?: string | null,
  icon?: string | null,
  name: string,
  unitState?: UnitState | null,
  useGroupRefereshSettings?: boolean | null,
  refreshRate?: number | null,
  isAlwaysOnline?: boolean | null,
  unitGroups?: Array< string | null > | null,
  location?: GeoLocationInput | null,
  configurations?: Array< ConfigurationInput | null > | null,
};

export type DataUnitInput = {
  unitId: string,
  typedId: string,
  clientId: string,
  isOnline?: boolean | null,
  location?: GeoLocationInput | null,
  lastUpdate?: number | null,
};

export type ClientUnitInput = {
  unitId: string,
  typedId: string,
  divisionId?: string | null,
  icon?: string | null,
  name?: string | null,
  unitGroups?: Array< string | null > | null,
  location?: GeoLocationInput | null,
  configurations?: Array< ConfigurationInput | null > | null,
};

export type UnitDeleteInput = {
  unitId: string,
  typedId?: string | null,
};

// Timed Log Data
export enum EventType {
  General = "General",
  TriggerStart = "TriggerStart",
  TriggerEnd = "TriggerEnd",
  StateStart = "StateStart",
  StateEnd = "StateEnd",
}


export type EventInput = {
  unitId: string,
  clientId: string,
  typedId: string,
  eventType: EventType,
  context?: string | null,
  data?: string | null,
  timestamp: number,
};

export type UnitSensorInput = {
  unitId: string,
  typedId: string,
  clientId?: string | null,
  name?: string | null,
  configurations?: Array< ConfigurationInput | null > | null,
  snoozes?: Array< SnoozeInput | null > | null,
  lastUpdate?: number | null,
};

export type SnoozeInput = {
  triggerId?: string | null,
  reason?: string | null,
  sevirity?: TriggerSevirity | null,
  from: number,
  to?: number | null,
};

export type DataUnitSensorInput = {
  unitId: string,
  typedId: string,
  clientId: string,
  min?: number | null,
  max?: number | null,
  total?: number | null,
  average?: number | null,
  count: number,
  lastValue: number,
  lastUpdate?: number | null,
  sevirity?: TriggerSevirity | null,
  calculatedStates?: Array< string > | null,
  occuringTriggers?: Array< string > | null,
  configurations?: Array< ConfigurationInput | null > | null,
};

export type UnitSensorResetInput = {
  unitId: string,
  typedId: string,
};

export enum ActionState {
  declared = "declared",
  redo = "redo",
  loaded = "loaded",
  requested = "requested",
}


export type ActionInput = {
  unitId: string,
  typedId: string,
  clientId?: string | null,
  name: string,
  byUser: string,
  actionState?: ActionState | null,
  addedTimestamp: number,
  lastUpdate?: number | null,
  deliveredTimestamp?: number | null,
  completedTimestamp?: number | null,
  payload?: string | null,
};

export type ActionDataInput = {
  actionState?: ActionState | null,
  addedTimestamp: number,
  lastUpdate?: number | null,
  deliveredTimestamp?: number | null,
  completedTimestamp?: number | null,
};

export type GetCommCacheInput = {
  unitId: string,
  typedId: string,
  clientId?: string | null,
  fromTime?: string | null,
  toTime?: string | null,
};

export type CommCacheInput = {
  unitId: string,
  typedId: string,
  clientId?: string | null,
  isInvalid?: boolean | null,
  fromTime?: number | null,
  fromState?: string | null,
  fromValue?: number | null,
  averageTime?: number | null,
  averageValue?: number | null,
  count?: number | null,
  toTime?: number | null,
  toState?: string | null,
  toValue?: number | null,
};

export type SubsUpdateInput = {
  clientId?: string | null,
  cc?: Array< CommCacheInput | null > | null,
  us?: Array< DataUnitSensorInput | null > | null,
  un?: Array< DataUnitInput | null > | null,
};

export type ListClientsQueryVariables = {
  nextToken?: string | null,
};

export type ListClientsQuery = {
  // Client Based Data
  listClients:  {
    items:  Array< {
      clientId: string,
      typedId: string,
      name: string,
      icon: string | null,
      location:  {
        lng: number,
        lat: number,
      } | null,
      contacts:  Array< {
        contactType: ContactType,
        contact: string,
      } > | null,
      brief: string | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type CreateClientMutationVariables = {
  input: ClientInput,
};

export type CreateClientMutation = {
  createClient:  {
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    location:  {
      lng: number,
      lat: number,
    } | null,
    contacts:  Array< {
      contactType: ContactType,
      contact: string,
    } > | null,
    brief: string | null,
  } | null,
};

export type UpdateClientMutationVariables = {
  input: ClientInput,
};

export type UpdateClientMutation = {
  createClient:  {
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    location:  {
      lng: number,
      lat: number,
    } | null,
    contacts:  Array< {
      contactType: ContactType,
      contact: string,
    } > | null,
    brief: string | null,
  } | null,
};

export type DeleteClientMutationVariables = {
  input: ClientDeleteInput,
};

export type DeleteClientMutation = {
  deleteClient:  {
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    location:  {
      lng: number,
      lat: number,
    } | null,
    contacts:  Array< {
      contactType: ContactType,
      contact: string,
    } > | null,
    brief: string | null,
  } | null,
};

export type ListThreadsQueryVariables = {
  input: ClientConnectionInput,
};

export type ListThreadsQuery = {
  listThreads:  Array< {
    clientId: string,
    typedId: string,
    context: string | null,
    brief: string | null,
    detail: string | null,
    listeners: Array< string | null > | null,
  } > | null,
};

export type CreateThreadMutationVariables = {
  input: ThreadInput,
};

export type CreateThreadMutation = {
  createThread:  {
    clientId: string,
    typedId: string,
    context: string | null,
    brief: string | null,
    detail: string | null,
    listeners: Array< string | null > | null,
  } | null,
};

export type UpdateThreadMutationVariables = {
  input: ThreadInput,
};

export type UpdateThreadMutation = {
  updateThread:  {
    clientId: string,
    typedId: string,
    context: string | null,
    brief: string | null,
    detail: string | null,
    listeners: Array< string | null > | null,
  } | null,
};

export type AddListenerMutationVariables = {
  typedId?: string | null,
  listener?: string | null,
};

export type AddListenerMutation = {
  addListener:  {
    clientId: string,
    typedId: string,
    context: string | null,
    brief: string | null,
    detail: string | null,
    listeners: Array< string | null > | null,
  } | null,
};

export type RemoveListenerMutationVariables = {
  typedId?: string | null,
  listener?: string | null,
};

export type RemoveListenerMutation = {
  removeListener:  {
    clientId: string,
    typedId: string,
    context: string | null,
    brief: string | null,
    detail: string | null,
    listeners: Array< string | null > | null,
  } | null,
};

export type DeleteThreadMutationVariables = {
  input: ClientDeleteInput,
};

export type DeleteThreadMutation = {
  deleteThread:  {
    clientId: string,
    typedId: string,
    context: string | null,
    brief: string | null,
    detail: string | null,
    listeners: Array< string | null > | null,
  } | null,
};

export type ListCommentsQueryVariables = {
  input: ClientConnectionInput,
};

export type ListCommentsQuery = {
  listComments:  Array< {
    clientId: string,
    typedId: string,
    comment: string,
    created: number | null,
    updated: number | null,
    user: string,
  } > | null,
};

export type CreateCommentMutationVariables = {
  input?: UserCommentInput | null,
};

export type CreateCommentMutation = {
  createComment:  {
    clientId: string,
    typedId: string,
    comment: string,
    created: number | null,
    updated: number | null,
    user: string,
  } | null,
};

export type UdateCommentMutationVariables = {
  input?: UserCommentInput | null,
};

export type UdateCommentMutation = {
  updateComment:  {
    clientId: string,
    typedId: string,
    comment: string,
    created: number | null,
    updated: number | null,
    user: string,
  } | null,
};

export type DeleteCommentMutationVariables = {
  input: ClientDeleteInput,
};

export type DeleteCommentMutation = {
  deleteComment:  {
    clientId: string,
    typedId: string,
    comment: string,
    created: number | null,
    updated: number | null,
    user: string,
  } | null,
};

export type ListDashboardsQueryVariables = {
  input: ClientConnectionInput,
};

export type ListDashboardsQuery = {
  listDashboards:  {
    items:  Array< {
      clientId: string,
      typedId: string,
      name: string,
      icon: string | null,
      layout:  {
        lg:  Array< {
          i: string,
          x: number,
          y: number,
          w: number,
          h: number,
        } >,
        md:  Array< {
          i: string,
          x: number,
          y: number,
          w: number,
          h: number,
        } >,
        sm:  Array< {
          i: string,
          x: number,
          y: number,
          w: number,
          h: number,
        } >,
        xs:  Array< {
          i: string,
          x: number,
          y: number,
          w: number,
          h: number,
        } >,
      } | null,
      configurations:  Array< {
        key: string,
        value: string | null,
      } | null > | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type CreateDashboardMutationVariables = {
  input: DashboardInput,
};

export type CreateDashboardMutation = {
  createDashboard:  {
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    layout:  {
      lg:  Array< {
        i: string,
        x: number,
        y: number,
        w: number,
        h: number,
      } >,
      md:  Array< {
        i: string,
        x: number,
        y: number,
        w: number,
        h: number,
      } >,
      sm:  Array< {
        i: string,
        x: number,
        y: number,
        w: number,
        h: number,
      } >,
      xs:  Array< {
        i: string,
        x: number,
        y: number,
        w: number,
        h: number,
      } >,
    } | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
  } | null,
};

export type UpdateDashboardMutationVariables = {
  input: DashboardInput,
};

export type UpdateDashboardMutation = {
  updateDashboard:  {
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    layout:  {
      lg:  Array< {
        i: string,
        x: number,
        y: number,
        w: number,
        h: number,
      } >,
      md:  Array< {
        i: string,
        x: number,
        y: number,
        w: number,
        h: number,
      } >,
      sm:  Array< {
        i: string,
        x: number,
        y: number,
        w: number,
        h: number,
      } >,
      xs:  Array< {
        i: string,
        x: number,
        y: number,
        w: number,
        h: number,
      } >,
    } | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
  } | null,
};

export type DeleteDashboardMutationVariables = {
  input: ClientDeleteInput,
};

export type DeleteDashboardMutation = {
  deleteDashboard:  {
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    layout:  {
      lg:  Array< {
        i: string,
        x: number,
        y: number,
        w: number,
        h: number,
      } >,
      md:  Array< {
        i: string,
        x: number,
        y: number,
        w: number,
        h: number,
      } >,
      sm:  Array< {
        i: string,
        x: number,
        y: number,
        w: number,
        h: number,
      } >,
      xs:  Array< {
        i: string,
        x: number,
        y: number,
        w: number,
        h: number,
      } >,
    } | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
  } | null,
};

export type ListChartsQueryVariables = {
  input: ClientConnectionInput,
};

export type ListChartsQuery = {
  listCharts:  {
    items:  Array< {
      clientId: string,
      typedId: string,
      name: string,
      sensorType: string,
      breakOnError: boolean | null,
      geospread: boolean | null,
      min: number | null,
      max: number | null,
      measurementUnit: string,
      include:  Array< {
        unitIds: Array< string > | null,
        unitGroups: Array< string > | null,
        unitSensors: Array< string > | null,
      } | null > | null,
      exclude:  Array< {
        unitIds: Array< string > | null,
        unitGroups: Array< string > | null,
        unitSensors: Array< string > | null,
      } | null > | null,
      chartType: ChartType,
      durationFromType: DurationFromType,
      durationFrom: string,
      configurations:  Array< {
        key: string,
        value: string | null,
      } | null > | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type CreateChartMutationVariables = {
  input: ChartInput,
};

export type CreateChartMutation = {
  createChart:  {
    clientId: string,
    typedId: string,
    name: string,
    sensorType: string,
    breakOnError: boolean | null,
    geospread: boolean | null,
    min: number | null,
    max: number | null,
    measurementUnit: string,
    include:  Array< {
      unitIds: Array< string > | null,
      unitGroups: Array< string > | null,
      unitSensors: Array< string > | null,
    } | null > | null,
    exclude:  Array< {
      unitIds: Array< string > | null,
      unitGroups: Array< string > | null,
      unitSensors: Array< string > | null,
    } | null > | null,
    chartType: ChartType,
    durationFromType: DurationFromType,
    durationFrom: string,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
  } | null,
};

export type UpdateChartMutationVariables = {
  input: ChartInput,
};

export type UpdateChartMutation = {
  updateChart:  {
    clientId: string,
    typedId: string,
    name: string,
    sensorType: string,
    breakOnError: boolean | null,
    geospread: boolean | null,
    min: number | null,
    max: number | null,
    measurementUnit: string,
    include:  Array< {
      unitIds: Array< string > | null,
      unitGroups: Array< string > | null,
      unitSensors: Array< string > | null,
    } | null > | null,
    exclude:  Array< {
      unitIds: Array< string > | null,
      unitGroups: Array< string > | null,
      unitSensors: Array< string > | null,
    } | null > | null,
    chartType: ChartType,
    durationFromType: DurationFromType,
    durationFrom: string,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
  } | null,
};

export type DeleteChartMutationVariables = {
  input: ClientDeleteInput,
};

export type DeleteChartMutation = {
  deleteChart:  {
    clientId: string,
    typedId: string,
    name: string,
    sensorType: string,
    breakOnError: boolean | null,
    geospread: boolean | null,
    min: number | null,
    max: number | null,
    measurementUnit: string,
    include:  Array< {
      unitIds: Array< string > | null,
      unitGroups: Array< string > | null,
      unitSensors: Array< string > | null,
    } | null > | null,
    exclude:  Array< {
      unitIds: Array< string > | null,
      unitGroups: Array< string > | null,
      unitSensors: Array< string > | null,
    } | null > | null,
    chartType: ChartType,
    durationFromType: DurationFromType,
    durationFrom: string,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
  } | null,
};

export type ListTriggerableStatsQueryVariables = {
  input: ClientConnectionInput,
};

export type ListTriggerableStatsQuery = {
  listTriggerableStats:  {
    items:  Array< {
      clientId: string,
      typedId: string,
      statIndex: number | null,
      name: string | null,
      sensorType: string | null,
      measurementUnit: string | null,
      include:  Array< {
        unitIds: Array< string > | null,
        unitGroups: Array< string > | null,
        unitSensors: Array< string > | null,
      } | null > | null,
      exclude:  Array< {
        unitIds: Array< string > | null,
        unitGroups: Array< string > | null,
        unitSensors: Array< string > | null,
      } | null > | null,
      associatedChart: string | null,
      statType: StatisticsType,
      comparisionType: StatComparisionType,
      comparedToStatType: StatisticsType | null,
      comparisionValue: number | null,
      triggers:  Array< {
        id: string | null,
        contacts:  Array< {
          contactType: ContactType,
          contact: string,
        } > | null,
        name: string,
        description: string | null,
        notifyOnFailure: boolean | null,
        triggerSevirity: TriggerSevirity,
        triggerCondition: Conditions,
        value: number | null,
        state: string | null,
      } > | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type CreateTriggerableStatsMutationVariables = {
  input: TriggerableStatInput,
};

export type CreateTriggerableStatsMutation = {
  createTriggerableStats:  {
    clientId: string,
    typedId: string,
    statIndex: number | null,
    name: string | null,
    sensorType: string | null,
    measurementUnit: string | null,
    include:  Array< {
      unitIds: Array< string > | null,
      unitGroups: Array< string > | null,
      unitSensors: Array< string > | null,
    } | null > | null,
    exclude:  Array< {
      unitIds: Array< string > | null,
      unitGroups: Array< string > | null,
      unitSensors: Array< string > | null,
    } | null > | null,
    associatedChart: string | null,
    statType: StatisticsType,
    comparisionType: StatComparisionType,
    comparedToStatType: StatisticsType | null,
    comparisionValue: number | null,
    triggers:  Array< {
      id: string | null,
      contacts:  Array< {
        contactType: ContactType,
        contact: string,
      } > | null,
      name: string,
      description: string | null,
      notifyOnFailure: boolean | null,
      triggerSevirity: TriggerSevirity,
      triggerCondition: Conditions,
      value: number | null,
      state: string | null,
    } > | null,
  } | null,
};

export type UpdateTriggerableStatsMutationVariables = {
  input: TriggerableStatInput,
};

export type UpdateTriggerableStatsMutation = {
  updateTriggerableStats:  {
    clientId: string,
    typedId: string,
    statIndex: number | null,
    name: string | null,
    sensorType: string | null,
    measurementUnit: string | null,
    include:  Array< {
      unitIds: Array< string > | null,
      unitGroups: Array< string > | null,
      unitSensors: Array< string > | null,
    } | null > | null,
    exclude:  Array< {
      unitIds: Array< string > | null,
      unitGroups: Array< string > | null,
      unitSensors: Array< string > | null,
    } | null > | null,
    associatedChart: string | null,
    statType: StatisticsType,
    comparisionType: StatComparisionType,
    comparedToStatType: StatisticsType | null,
    comparisionValue: number | null,
    triggers:  Array< {
      id: string | null,
      contacts:  Array< {
        contactType: ContactType,
        contact: string,
      } > | null,
      name: string,
      description: string | null,
      notifyOnFailure: boolean | null,
      triggerSevirity: TriggerSevirity,
      triggerCondition: Conditions,
      value: number | null,
      state: string | null,
    } > | null,
  } | null,
};

export type DeleteTriggerableStatsMutationVariables = {
  input: ClientDeleteInput,
};

export type DeleteTriggerableStatsMutation = {
  deleteTriggerableStats:  {
    clientId: string,
    typedId: string,
    statIndex: number | null,
    name: string | null,
    sensorType: string | null,
    measurementUnit: string | null,
    include:  Array< {
      unitIds: Array< string > | null,
      unitGroups: Array< string > | null,
      unitSensors: Array< string > | null,
    } | null > | null,
    exclude:  Array< {
      unitIds: Array< string > | null,
      unitGroups: Array< string > | null,
      unitSensors: Array< string > | null,
    } | null > | null,
    associatedChart: string | null,
    statType: StatisticsType,
    comparisionType: StatComparisionType,
    comparedToStatType: StatisticsType | null,
    comparisionValue: number | null,
    triggers:  Array< {
      id: string | null,
      contacts:  Array< {
        contactType: ContactType,
        contact: string,
      } > | null,
      name: string,
      description: string | null,
      notifyOnFailure: boolean | null,
      triggerSevirity: TriggerSevirity,
      triggerCondition: Conditions,
      value: number | null,
      state: string | null,
    } > | null,
  } | null,
};

export type ListUnitGroupsQueryVariables = {
  input: ClientConnectionInput,
};

export type ListUnitGroupsQuery = {
  listUnitGroups:  {
    items:  Array< {
      clientId: string,
      typedId: string,
      name: string,
      icon: string | null,
      configurations:  Array< {
        key: string,
        value: string | null,
      } | null > | null,
      priority: number | null,
      refreshRate: number | null,
      isAlwaysOnline: boolean | null,
      unitSensorRenaming:  Array< {
        alias: string | null,
        name: string | null,
      } | null > | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type CreateUnitGroupMutationVariables = {
  input: UnitGroupInput,
};

export type CreateUnitGroupMutation = {
  createUnitGroup:  {
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
    refreshRate: number | null,
    isAlwaysOnline: boolean | null,
    priority: number | null,
    unitSensorRenaming:  Array< {
      alias: string | null,
      name: string | null,
    } | null > | null,
  } | null,
};

export type UpdateUnitGroupMutationVariables = {
  input: UnitGroupInput,
};

export type UpdateUnitGroupMutation = {
  updateUnitGroup:  {
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
    refreshRate: number | null,
    isAlwaysOnline: boolean | null,
    priority: number | null,
    unitSensorRenaming:  Array< {
      alias: string | null,
      name: string | null,
    } | null > | null,
  } | null,
};

export type DeleteUnitGroupMutationVariables = {
  input: ClientDeleteInput,
};

export type DeleteUnitGroupMutation = {
  deleteUnitGroup:  {
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
    refreshRate: number | null,
    isAlwaysOnline: boolean | null,
    priority: number | null,
    unitSensorRenaming:  Array< {
      alias: string | null,
      name: string | null,
    } | null > | null,
  } | null,
};

export type ListSensorTypesQuery = {
  // Unit Based Data
  listSensorTypes:  {
    items:  Array< {
      clientId: string,
      typedId: string,
      name: string,
      icon: string | null,
      configurations:  Array< {
        key: string,
        value: string | null,
      } | null > | null,
      isStateBased: boolean | null,
      possibleStates: Array< string | null > | null,
      measurement: string,
      commUnit: string,
      maxValue: number | null,
      minValue: number | null,
      significantDifference: number | null,
      significantTimeDifference: number | null,
      isOutput: boolean | null,
      conditionalState:  Array< {
        condition: Conditions,
        value: number,
        state: string | null,
      } | null > | null,
      possibleActions:  Array< {
        name: string,
        possiblePayloads:  Array< {
          payloadType: PayloadType | null,
          payloadOptions:  Array< {
            icon: string,
            key: string,
            text: string,
            value: string,
          } > | null,
        } | null > | null,
      } | null > | null,
    } > | null,
  } | null,
};

export type CreateSensorTypeMutationVariables = {
  input: SensorTypeInput,
};

export type CreateSensorTypeMutation = {
  createSensorType:  {
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
    isStateBased: boolean | null,
    possibleStates: Array< string | null > | null,
    measurement: string,
    commUnit: string,
    maxValue: number | null,
    minValue: number | null,
    significantDifference: number | null,
    significantTimeDifference: number | null,
    isOutput: boolean | null,
    conditionalState:  Array< {
      condition: Conditions,
      value: number,
      state: string | null,
    } | null > | null,
    possibleActions:  Array< {
      name: string,
      possiblePayloads:  Array< {
        payloadType: PayloadType | null,
        payloadOptions:  Array< {
          icon: string,
          key: string,
          text: string,
          value: string,
        } > | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type UpdateSensorTypeMutationVariables = {
  input: SensorTypeInput,
};

export type UpdateSensorTypeMutation = {
  updateSensorType:  {
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
    isStateBased: boolean | null,
    possibleStates: Array< string | null > | null,
    measurement: string,
    commUnit: string,
    maxValue: number | null,
    minValue: number | null,
    significantDifference: number | null,
    significantTimeDifference: number | null,
    isOutput: boolean | null,
    conditionalState:  Array< {
      condition: Conditions,
      value: number,
      state: string | null,
    } | null > | null,
    possibleActions:  Array< {
      name: string,
      possiblePayloads:  Array< {
        payloadType: PayloadType | null,
        payloadOptions:  Array< {
          icon: string,
          key: string,
          text: string,
          value: string,
        } > | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type DeleteSensorTypeMutationVariables = {
  input: ClientDeleteInput,
};

export type DeleteSensorTypeMutation = {
  deleteSensorType:  {
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
    isStateBased: boolean | null,
    possibleStates: Array< string | null > | null,
    measurement: string,
    commUnit: string,
    maxValue: number | null,
    minValue: number | null,
    significantDifference: number | null,
    significantTimeDifference: number | null,
    isOutput: boolean | null,
    conditionalState:  Array< {
      condition: Conditions,
      value: number,
      state: string | null,
    } | null > | null,
    possibleActions:  Array< {
      name: string,
      possiblePayloads:  Array< {
        payloadType: PayloadType | null,
        payloadOptions:  Array< {
          icon: string,
          key: string,
          text: string,
          value: string,
        } > | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type ListUnitsQueryVariables = {
  input: UnitConnectionInput,
};

export type ListUnitsQuery = {
  listUnits:  {
    items:  Array< {
      unitId: string,
      clientId: string,
      typedId: string,
      name: string,
      icon: string | null,
      unitState: UnitState | null,
      useGroupRefereshSettings: boolean | null,
      refreshRate: number | null,
      isAlwaysOnline: boolean | null,
      isOnline: boolean | null,
      lastUpdate: number | null,
      location:  {
        lat: number,
        lng: number,
      } | null,
      unitGroups: Array< string | null > | null,
      configurations:  Array< {
        key: string,
        value: string | null,
      } | null > | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type CreateUnitMutationVariables = {
  input: SuperUnitInput,
};

export type CreateUnitMutation = {
  createUnit:  {
    unitId: string,
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    unitState: UnitState | null,
    useGroupRefereshSettings: boolean | null,
    refreshRate: number | null,
    isAlwaysOnline: boolean | null,
    isOnline: boolean | null,
    lastUpdate: number | null,
    location:  {
      lat: number,
      lng: number,
    } | null,
    unitGroups: Array< string | null > | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
  } | null,
};

export type UpdateUnitSuperMutationVariables = {
  input: SuperUnitInput,
};

export type UpdateUnitSuperMutation = {
  updateUnitSuper:  {
    unitId: string,
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    unitState: UnitState | null,
    useGroupRefereshSettings: boolean | null,
    refreshRate: number | null,
    isAlwaysOnline: boolean | null,
    isOnline: boolean | null,
    lastUpdate: number | null,
    location:  {
      lat: number,
      lng: number,
    } | null,
    unitGroups: Array< string | null > | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
  } | null,
};

export type UpdateUnitDataMutationVariables = {
  input: DataUnitInput,
};

export type UpdateUnitDataMutation = {
  updateUnitData:  {
    unitId: string,
    typedId: string,
    clientId: string,
    isOnline: boolean | null,
    lastUpdate: number | null,
    location:  {
      lat: number,
      lng: number,
    } | null,
  } | null,
};

export type UpdateUnitClientMutationVariables = {
  input: ClientUnitInput,
};

export type UpdateUnitClientMutation = {
  updateUnitClient:  {
    unitId: string,
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    unitState: UnitState | null,
    refreshRate: number | null,
    isAlwaysOnline: boolean | null,
    isOnline: boolean | null,
    lastUpdate: number | null,
    location:  {
      lat: number,
      lng: number,
    } | null,
    unitGroups: Array< string | null > | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
  } | null,
};

export type DeleteUnitMutationVariables = {
  input: UnitDeleteInput,
};

export type DeleteUnitMutation = {
  deleteUnit:  {
    unitId: string,
    clientId: string,
    typedId: string,
    name: string,
    icon: string | null,
    unitState: UnitState | null,
    useGroupRefereshSettings: boolean | null,
    refreshRate: number | null,
    isAlwaysOnline: boolean | null,
    isOnline: boolean | null,
    lastUpdate: number | null,
    location:  {
      lat: number,
      lng: number,
    } | null,
    unitGroups: Array< string | null > | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
  } | null,
};

export type UnitSubsciptionSubscription = {
  // 
  // 
  // createUnit(): Unit
  // @aws_subscribe(mutations: ["createUnit"])
  // updateUnitSuper(): Unit
  // @aws_subscribe(mutations: ["updateUnitSuper"])
  updateUnitData:  {
    unitId: string,
    typedId: string,
    clientId: string,
    lastUpdate: number | null,
    location:  {
      lat: number,
      lng: number,
    } | null,
  } | null,
};

export type ListUnitEventsQueryVariables = {
  input: UnitConnectionInput,
};

export type ListUnitEventsQuery = {
  listUnitEvents:  {
    items:  Array< {
      unitId: string,
      clientId: string,
      typedId: string,
      eventType: EventType,
      context: string | null,
      data: string | null,
      timestamp: number,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type CreateUnitEventMutationVariables = {
  input: EventInput,
};

export type CreateUnitEventMutation = {
  createUnitEvent:  {
    unitId: string,
    clientId: string,
    typedId: string,
    eventType: EventType,
    context: string | null,
    data: string | null,
    timestamp: number,
  } | null,
};

export type DeleteUnitEventMutationVariables = {
  input: UnitDeleteInput,
};

export type DeleteUnitEventMutation = {
  deleteUnitEvent:  {
    unitId: string,
    clientId: string,
    typedId: string,
    eventType: EventType,
    context: string | null,
    data: string | null,
    timestamp: number,
  } | null,
};

export type ListUnitSensorsQueryVariables = {
  input: UnitConnectionInput,
};

export type ListUnitSensorsQuery = {
  listUnitSensors:  {
    items:  Array< {
      unitId: string,
      clientId: string | null,
      typedId: string,
      name: string | null,
      configurations:  Array< {
        key: string,
        value: string | null,
      } | null > | null,
      lastValue: number,
      lastUpdate: number | null,
      sevirity: TriggerSevirity | null,
      min: number,
      max: number,
      total: number,
      average: number,
      calculatedStates: Array< string > | null,
      occuringTriggers: Array< string > | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type CreateUnitSensorMutationVariables = {
  input: UnitSensorInput,
};

export type CreateUnitSensorMutation = {
  createUnitSensor:  {
    unitId: string,
    clientId: string | null,
    typedId: string,
    name: string | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
    lastValue: number,
    lastUpdate: number | null,
    sevirity: TriggerSevirity | null,
    min: number,
    max: number,
    total: number,
    average: number,
    calculatedStates: Array< string > | null,
    occuringTriggers: Array< string > | null,
  } | null,
};

export type UpdateUnitSensorDataMutationVariables = {
  input: DataUnitSensorInput,
};

export type UpdateUnitSensorDataMutation = {
  updateUnitSensorData:  {
    unitId: string,
    clientId: string,
    typedId: string,
    lastValue: number,
    lastUpdate: number | null,
    sevirity: TriggerSevirity | null,
    min: number | null,
    max: number | null,
    total: number | null,
    average: number | null,
  } | null,
};

export type UpdateUnitSensorClientMutationVariables = {
  input: UnitSensorInput,
};

export type UpdateUnitSensorClientMutation = {
  updateUnitSensorClient:  {
    unitId: string,
    clientId: string | null,
    typedId: string,
    name: string | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
    lastValue: number,
    lastUpdate: number | null,
    sevirity: TriggerSevirity | null,
    min: number,
    max: number,
    total: number,
    average: number,
    calculatedStates: Array< string > | null,
    occuringTriggers: Array< string > | null,
  } | null,
};

export type ResetUnitSensorMutationVariables = {
  input: UnitSensorResetInput,
};

export type ResetUnitSensorMutation = {
  resetUnitSensor:  {
    unitId: string,
    clientId: string | null,
    typedId: string,
    name: string | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
    lastValue: number,
    lastUpdate: number | null,
    sevirity: TriggerSevirity | null,
    min: number,
    max: number,
    total: number,
    average: number,
    calculatedStates: Array< string > | null,
    occuringTriggers: Array< string > | null,
  } | null,
};

export type DeleteUnitSensorMutationVariables = {
  input: UnitDeleteInput,
};

export type DeleteUnitSensorMutation = {
  deleteUnitSensor:  {
    unitId: string,
    clientId: string | null,
    typedId: string,
    name: string | null,
    configurations:  Array< {
      key: string,
      value: string | null,
    } | null > | null,
    lastValue: number,
    lastUpdate: number | null,
    sevirity: TriggerSevirity | null,
    min: number,
    max: number,
    total: number,
    average: number,
    calculatedStates: Array< string > | null,
    occuringTriggers: Array< string > | null,
  } | null,
};

export type UnitSensorSubscriptionSubscription = {
  // updateUnitClient(): Unit
  // @aws_subscribe(mutations: ["updateUnitClient"])
  // deleteUnit(): Unit
  // @aws_subscribe(mutations: ["deleteUnit"])
  // 
  // 
  // createUnitEvent(): EventLog
  // @aws_subscribe(mutations: ["createUnitEvent"])
  // deleteUnitEvent(): EventLog
  // @aws_subscribe(mutations: ["deleteUnitEvent"])
  // createAction(): Action
  // @aws_subscribe(mutations: ["createAction"])
  // updateActionData(): Action
  // @aws_subscribe(mutations: ["updateActionData"])
  // deleteAction(): Action
  // @aws_subscribe(mutations: ["deleteAction"])
  // 
  // 
  // createUnitSensor(): UnitSensor
  // @aws_subscribe(mutations: ["createUnitSensor"])
  updateUnitSensorData:  {
    unitId: string,
    clientId: string,
    typedId: string,
    lastValue: number,
    lastUpdate: number | null,
    sevirity: TriggerSevirity | null,
    min: number | null,
    max: number | null,
    total: number | null,
    average: number | null,
  } | null,
};

export type ListActionsQueryVariables = {
  input: UnitConnectionInput,
};

export type ListActionsQuery = {
  listActions:  {
    items:  Array< {
      unitId: string,
      clientId: string | null,
      typedId: string,
      name: string,
      byUser: string,
      actionState: ActionState | null,
      addedTimestamp: number,
      recievedTimestamp: number | null,
      completedTimestamp: number | null,
      payload: string | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type CreateActionMutationVariables = {
  input: ActionInput,
};

export type CreateActionMutation = {
  createAction:  {
    unitId: string,
    clientId: string | null,
    typedId: string,
    name: string,
    byUser: string,
    actionState: ActionState | null,
    addedTimestamp: number,
    recievedTimestamp: number | null,
    completedTimestamp: number | null,
    payload: string | null,
  } | null,
};

export type UpdateActionDataMutationVariables = {
  input: ActionDataInput,
};

export type UpdateActionDataMutation = {
  updateActionData:  {
    unitId: string,
    clientId: string | null,
    typedId: string,
    name: string,
    byUser: string,
    actionState: ActionState | null,
    addedTimestamp: number,
    recievedTimestamp: number | null,
    completedTimestamp: number | null,
    payload: string | null,
  } | null,
};

export type DeleteActionMutationVariables = {
  input: UnitDeleteInput,
};

export type DeleteActionMutation = {
  deleteAction:  {
    unitId: string,
    clientId: string | null,
    typedId: string,
    name: string,
    byUser: string,
    actionState: ActionState | null,
    addedTimestamp: number,
    recievedTimestamp: number | null,
    completedTimestamp: number | null,
    payload: string | null,
  } | null,
};

export type ListUnitCommsQueryVariables = {
  input: GetCommCacheInput,
};

export type ListUnitCommsQuery = {
  listUnitComms:  {
    items:  Array< {
      unitId: string,
      clientId: string | null,
      typedId: string,
      fromTime: number | null,
      fromValue: number | null,
      fromState: string | null,
      isInvalid: boolean | null,
      averageTime: number | null,
      averageValue: number | null,
      count: number | null,
      toTime: number | null,
      toValue: number | null,
      toState: string | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type CreateCommCacheMutationVariables = {
  input: CommCacheInput,
};

export type CreateCommCacheMutation = {
  createCommCache:  {
    unitId: string,
    clientId: string | null,
    typedId: string,
    fromTime: number | null,
    fromValue: number | null,
    fromState: string | null,
    isInvalid: boolean | null,
    averageTime: number | null,
    averageValue: number | null,
    count: number | null,
    toTime: number | null,
    toValue: number | null,
    toState: string | null,
  } | null,
};

export type UpdateCommCacheMutationVariables = {
  input: CommCacheInput,
};

export type UpdateCommCacheMutation = {
  updateCommCache:  {
    unitId: string,
    clientId: string | null,
    typedId: string,
    fromTime: number | null,
    fromValue: number | null,
    fromState: string | null,
    isInvalid: boolean | null,
    averageTime: number | null,
    averageValue: number | null,
    count: number | null,
    toTime: number | null,
    toValue: number | null,
    toState: string | null,
  } | null,
};

export type CommSubscriptionSubscription = {
  // createChart(): Chart
  // @aws_subscribe(mutations: ["createChart"])
  // updateChart(): Chart
  // @aws_subscribe(mutations: ["updateChart"])
  // deleteChart(): Chart
  // @aws_subscribe(mutations: ["deleteChart"])
  // 
  // createTriggerableStats(): TriggerableStat
  // @aws_subscribe(mutations: ["createTriggerableStats"])
  // updateTriggerableStats(): TriggerableStat
  // @aws_subscribe(mutations: ["updateTriggerableStats"])
  // deleteTriggerableStats(): TriggerableStat
  // @aws_subscribe(mutations: ["deleteTriggerableStats"])
  // 
  // createDashboard(): Dashboard
  // @aws_subscribe(mutations: ["createDashboard"])
  // updateDashboard(): Dashboard
  // @aws_subscribe(mutations: ["updateDashboard"])
  // deleteDashboard(): Dashboard
  // @aws_subscribe(mutations: ["deleteDashboard"])
  // 
  // 
  // createThread(): Thread
  // @aws_subscribe(mutations: ["createThread"])
  // updateThread(): Thread
  // @aws_subscribe(mutations: ["updateThread"])
  // addListener(): Thread
  // @aws_subscribe(mutations: ["addListener"])
  // removeListener(): Thread
  // @aws_subscribe(mutations: ["removeListener"])
  // deleteThread(): Thread
  // @aws_subscribe(mutations: ["deleteThread"])
  // 
  // 
  // createComment(): UserComment
  // @aws_subscribe(mutations: ["createComment"])
  // updateComment(): UserComment
  // @aws_subscribe(mutations: ["updateComment"])
  // deleteComment(): UserComment
  // @aws_subscribe(mutations: ["deleteComment"])
  // 
  // 
  // createUnitGroup(): UnitGroup
  // @aws_subscribe(mutations: ["createUnitGroup"])
  // updateUnitGroup(): UnitGroup
  // @aws_subscribe(mutations: ["updateUnitGroup"])
  // deleteUnitGroup(): UnitGroup
  // @aws_subscribe(mutations: ["deleteUnitGroup"])
  // 
  // 
  // createClient(): Client
  // @aws_subscribe(mutations: ["createClient"])
  // updateClient(): Client
  // @aws_subscribe(mutations: ["updateClient"])
  // deleteClient(): Client
  // @aws_subscribe(mutations: ["deleteClient"])
  // 
  // 
  // createCommCache(): CommCache
  // @aws_subscribe(mutations: ["createCommCache"])
  updateCommCache:  {
    unitId: string,
    clientId: string | null,
    typedId: string,
    fromTime: number | null,
    fromValue: number | null,
    fromState: string | null,
    isInvalid: boolean | null,
    averageTime: number | null,
    averageValue: number | null,
    count: number | null,
    toTime: number | null,
    toValue: number | null,
    toState: string | null,
  } | null,
};

export type UpdateSubscribersMutationVariables = {
  input: SubsUpdateInput,
};

export type UpdateSubscribersMutation = {
  updateSubscribers:  {
    cc:  Array< {
      unitId: string,
      clientId: string | null,
      typedId: string,
      fromTime: number | null,
      fromValue: number | null,
      fromState: string | null,
      isInvalid: boolean | null,
      averageTime: number | null,
      averageValue: number | null,
      count: number | null,
      toTime: number | null,
      toValue: number | null,
      toState: string | null,
    } | null > | null,
    us:  Array< {
      unitId: string,
      clientId: string,
      typedId: string,
      lastValue: number,
      lastUpdate: number | null,
      sevirity: TriggerSevirity | null,
      min: number | null,
      max: number | null,
      total: number | null,
      average: number | null,
    } | null > | null,
    un:  Array< {
      unitId: string,
      typedId: string,
      clientId: string,
      lastUpdate: number | null,
      location:  {
        lat: number,
        lng: number,
      } | null,
    } | null > | null,
  } | null,
};

export type UpdateSubscriptionSubscription = {
  updateSubscribers:  {
    cc:  Array< {
      unitId: string,
      clientId: string | null,
      typedId: string,
      fromTime: number | null,
      fromValue: number | null,
      fromState: string | null,
      isInvalid: boolean | null,
      averageTime: number | null,
      averageValue: number | null,
      count: number | null,
      toTime: number | null,
      toValue: number | null,
      toState: string | null,
    } | null > | null,
    us:  Array< {
      unitId: string,
      clientId: string,
      typedId: string,
      lastValue: number,
      lastUpdate: number | null,
      sevirity: TriggerSevirity | null,
      min: number | null,
      max: number | null,
      total: number | null,
      average: number | null,
    } | null > | null,
    un:  Array< {
      unitId: string,
      typedId: string,
      clientId: string,
      lastUpdate: number | null,
      location:  {
        lat: number,
        lng: number,
      } | null,
    } | null > | null,
  } | null,
};



// WEBPACK FOOTER //
// ./src/services/graphql/Models.ts